import { useRef } from "react";
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";

const HandleUpdateTextSelf = (field, newValue, targetID, route, debounceUpdate, setElement = null) => {
  // Actualizar el estado localmente antes de la petición

  if (setElement) {
    setElement((prev) => ({
      ...prev,
      [field]: newValue,
    }));
  }


  if (debounceUpdate.current) {
    clearTimeout(debounceUpdate.current);
  }

  // Configurar nuevo debounce
  debounceUpdate.current = setTimeout(async () => {
    try {
      await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
        [field]: newValue,
      });

      toast.success("Dato actualizado con éxito!")
    } catch (e) {
      toast.error("Error al actualizar el dato: " + e);
    }
  }, 1000);
};

export default HandleUpdateTextSelf